module.exports = __webpack_public_path__ + "img/16.e3873f63.png";